import React from 'react' 
import styled from 'styled-components'
import { Container, StyledTitleRight } from './styled'


const Contact = () => {
    return (
        <Container className="container has-text-centered" id="contact">
            <StyledTitleRight>4. Get in touch</StyledTitleRight>
            <Content className="content">
                <p>
                    Feel free to reach out to me on my email for feedback or any opportunity. I'd love to hear.

                </p>
                <Inset>@mwangishadrack5@gmail.com</Inset>
            </Content>
        </Container>
    )
}

const Content = styled.p `
    color: #a7a2a2;
    margin-bottom: 3rem;
`

const Inset = styled.p `
    color:  #da6c36;
    text-decoration: underline;
`

export default Contact;